<template>
  <el-dialog ref="dialog" :visible="visible" @close="$emit('update:visible', false)" class="dialog-w40">
    <h2 class="text-center mt-0">Подтвердите, что хотите удалить выделенные заказы</h2>

    <div class="row mt-4">
      <div class="col-12">
        <el-table size="small" :data="items" max-height="100%" border>
          <el-table-column prop="number" label="Номер заказа" min-width="140" />
          <el-table-column prop="status.title" label="Статус заказа" min-width="160"/>
          <el-table-column prop="includeAttachedFiles" label="Наличие вложений" min-width="140">
            <template slot-scope="scope">
              {{scope.row.includeAttachedFiles ? 'Да': 'Нет'}}
            </template>
          </el-table-column>
          <el-table-column label="" width="42">
            <template slot-scope="scope">
              <i class="el-icon-close font-weight-bold pointer" @click="onDeleteFromTable(scope.row.id)" />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12 col-lg-6 mx-auto mb-3 mb-lg-0">
        <el-button class="w-100" @click="onCancel">Отменить</el-button>
      </div>
      <div class="col-12 col-lg-6 mx-auto">
        <el-button class="w-100" type="danger" @click="onApply">Удалить</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    items: Array,
  },
  methods: {
    onDeleteFromTable(id) {
      this.$emit('deleteId', id);
    },

    onCancel() {
      this.$emit('update:visible', false);
    },
    onApply() {
      this.$emit('openConfirmation');
    },
  },
  watch: {
    items(newVal) {
      if (!newVal.length) {
        this.$emit('update:visible', false);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.el-icon-close {
  font-size: 20px;
}
</style>
